import React, {Component} from 'react';

import {IDropdownOption} from "office-ui-fabric-react";
import School from "../models/School";
import * as H from "history";
import { friendlySchoolName } from "../utils/Utils";
import { AccountInfo } from '@azure/msal-browser';
import { ComboBox } from 'office-ui-fabric-react/lib-commonjs';
import SchoolLicenseBanner from './SchoolLicenseBanner';
import {SchoolsCanAccessResponse} from "../models/SchoolsCanAccessResponse";

interface CDBSchoolSelectorProps {
    
    tenantId: string;
    schoolCode?: string;
    
    schoolsCanAccess: SchoolsCanAccessResponse | undefined,
    user: AccountInfo | undefined,
    userIsCdbEmployee: boolean,
    selectedOptionOverride?: undefined | "manage-tenant";
    history: H.History
}

interface CDBSchoolSelectorState {
}

export default class CDBSchoolSelector extends Component<CDBSchoolSelectorProps, CDBSchoolSelectorState> {

    static displayName = CDBSchoolSelector.name;

    constructor(props: CDBSchoolSelectorProps) {
        super(props);

        this.state = {
        };
    }

    async componentDidMount() {
    }
    
    async componentDidUpdate(prevProps: CDBSchoolSelectorProps, prevState: CDBSchoolSelectorState): Promise<void> {
    }
    
    private _onSchoolSelected = async (event: any, o?: IDropdownOption) => {
        if (o) {
            
            if(o.key === "manage-tenant")
            {
                this.props.history.push(`/manage-tenant/${this.props.user!.tenantId}`);
            }
            else
            {
                const school = o.data as School;
                this.props.history.push(`/manage/${school.tenantId}/${school.schoolCode}`);
            }
        }
    };
    
    calculateOptions(): IDropdownOption[]
    {
        let options: IDropdownOption[] = [];
        if (this.props.schoolsCanAccess)
        {
            options = this.props.schoolsCanAccess.schoolsWithAccessLevels.map((schoolWithAccessLevel) => {
                return {
                    key: schoolWithAccessLevel.school.schoolCode!,
                    text: friendlySchoolName(schoolWithAccessLevel.school),
                    data: schoolWithAccessLevel.school
                } as IDropdownOption;
            });
        }


        if (this.props.schoolsCanAccess?.tenantManager)
        {
            options.splice(0, 0, {
                key: "manage-tenant",
                text: "All Schools",
                data: {}
            });
        }
        
        return options;
        
    }
    
    renderSelector(tenantId: string,schoolCode: string | undefined,selectedKeyOverride: undefined | "manage-tenant"): JSX.Element
    {
        const options = this.calculateOptions();
        if(options.length === 0)
        {
            return (<div className={"cdb-admin-school-selector"}/>);
        }

        let selectedKey: string | null = null;
        let selectedSchool: School | undefined = undefined;

        if(this.props.selectedOptionOverride)
        {
            selectedKey = this.props.selectedOptionOverride;
        }
        else if(schoolCode)
        {
            selectedKey = schoolCode;
            selectedSchool = this.props.schoolsCanAccess?.schoolsWithAccessLevels.filter(sca => sca.school.tenantId === tenantId && sca.school.schoolCode == schoolCode)[0]?.school;
        }
        
        
        return (
            <div className={"cdb-admin-school-selector"}>
                <div className="cdb-admin-content p-left-1rem">
                    <ComboBox
                        label=""
                        selectedKey={selectedKeyOverride ?? selectedKey}
                        onChange={this._onSchoolSelected}
                        placeholder="Select School"
                        options={options}
                        className={"cdb-admin-school-selector-options"}
                        autoComplete={'on'}
                        allowFreeform={false}
                        autoCapitalize={'off'}
                    />
                </div>
                <SchoolLicenseBanner school={selectedSchool}/>
            </div>
        );
    }

    render() {
        if (!this.props.user) {
            return null;
        }

        if (this.props.userIsCdbEmployee) {
            return null;
        }

        return this.renderSelector(this.props.tenantId, this.props.schoolCode, this.props.selectedOptionOverride);
    }
}